import React from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./Views/ProtectedRoute";
import Dashboard from "./Views/Dashboard/Dashboard";
import NotFound from "./Views/NotFound/NotFound";
import { AppProvider } from "@toolpad/core/AppProvider";
import {
  routes,
  protectedRoutes,
  profileRoutes,
  profileUserprovider,
} from "./routes/index";
import { useSelector } from "react-redux";
import { useToolpadRouter } from "./hooks/toolpadRouter";
import IconRadaria from "./assets/images/logotipos/RADARIA-LOGOTIPO01.png";
import {
  NAVIGATION,
  demoTheme,
} from "./components/SidebarRunner/SidebarRunner";
import useCheckSession from "./hooks/useCheckSession";
import { ApolloProvider } from "@apollo/client";
import { client } from "./services/graphql/client";
import { getNavigationProvider } from "./components/SidebarProviderService/SiderProvider";
import DashboardProvider from "./Views/DashboardServices/DashboardProvider";
import useScrollToTop from "./hooks/UseScrollToTop";

const App = () => {
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  const { rol } = useSelector((state) => state.userReducer);
  const navigation = rol === "Runner" ? NAVIGATION : getNavigationProvider(rol);

  const router = useToolpadRouter();
  useCheckSession();
  useScrollToTop();
  return (
    <ApolloProvider client={client}>
      <AppProvider
        navigation={navigation}
        router={router}
        branding={{
          logo: <img src={IconRadaria} alt="Mi Logo" width={150} />,
          title: "",
          homeUrl: "",
        }}
        theme={demoTheme}
      >
        <Routes>
          {/* Rutas públicas */}
          {routes.map((page, index) => (
            <Route {...page} key={index} />
          ))}

          {/* Rutas protegidas */}
          <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
            {/* Rutas dentro del Dashboard */}
            <Route path="/dashboard" element={<Dashboard />}>
              {profileRoutes.map((page, index) => (
                <Route {...page} key={index} />
              ))}
            </Route>
            <Route path="/dashboard-provider" element={<DashboardProvider />}>
              {profileUserprovider.map((page, index) => (
                <Route {...page} key={index} />
              ))}
            </Route>

            {protectedRoutes.map((page, index) => (
              <Route {...page} key={index} />
            ))}
          </Route>

          {/* Ruta para 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AppProvider>
    </ApolloProvider>
  );
};

export default App;
